import { API_INSTANCE_NO_CREDENTIALS } from "../../../utils/service-http"

export const get3DViewerElements = (cluster) => {
  const data = [
    '03001',
    ...cluster.modules.flatMap(mod => {
      return ([mod.id , ...(mod.slottedDevicesForBOM?.front?.map(d => d.id) || [])]);
    }),
    'NTSXMP0000H'
  ];

  const headers = {
    Authorization: process.env.REACT_APP_3D_VIEWER_AUTH_TOKEN
  };

  return API_INSTANCE_NO_CREDENTIALS.post(
    process.env.REACT_APP_3D_VIEWER_AUTO_COMPOSITION_ENDPOINT,
    data, {
      headers
    });
}

export const get3DViewerElementsNewAPI = (cluster) => {
  const products = cluster.modules.map(mod => {
    return {refs: [mod.id , ...(mod.slottedDevicesForBOM?.front?.map(d => d.id) || [])]};
  });

  products.push({refs: ['NTSXMP0000H']});

  const data = {
    systemsConstraints: {},
    products
  };

  const headers = {
    Authorization: process.env.REACT_APP_3D_VIEWER_AUTH_TOKEN
  };

  return API_INSTANCE_NO_CREDENTIALS.post(
    process.env.REACT_APP_3D_VIEWER_SWITCHBOARD,
    data, {
      headers
    });
}

export const get3DViewerAssemblyComposition = (data) => {
  const headers = {
    Authorization: process.env.REACT_APP_3D_VIEWER_AUTH_TOKEN
  };

  return API_INSTANCE_NO_CREDENTIALS.post(
    process.env.REACT_APP_3D_VIEWER_ASSEMBLY_COMPOSITION,
    data, {
      headers
    });
}
